export const environment = {
  apiUrl: 'https://api-fdsolution.codebnb.me/api/v1',
  production: true
};
